/**
 * Curve2D resource slice entry point (ADR-0031): claims the Bézier path a Path2D
 * holds. It decodes to plain numbers, so there is no `build.ts`. THREE-free and
 * React-free, so a claim consumer pulls in no renderer.
 */
import { registerResourceSlice } from '../../sliceRegistration';
registerResourceSlice({
    slice: 'curve2d',
    kind: 'godot-text',
    typeNames: ['Curve2D'],
    busType: 'resource',
});
export { resolveCurve2D, tessellateCurve2D } from './decode';
//# sourceMappingURL=index.js.map